import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinmagarpatta() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Magarpatta City',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Magarpatta City',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Services in Magarpatta City, catering to the transportation needs of IT companies, corporate offices, and business parks within the township. Our fleet of premium sedans, SUVs, and executive vehicles ensures comfortable, safe, and on-time travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, client visits, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium corporate travel experience for businesses operating in and around Magarpatta City.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

 "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
{
"name": "Magarpatta IT Cab Service",
"description": "Magarpatta IT Cab Service offers a comprehensive transportation solution for employees working in Magarpatta IT Park. With a focus on punctuality, safety, and comfort, the service provides GPS-enabled vehicles, trained drivers, and structured pickup and drop points across Hadapsar and surrounding areas. It is designed to support multi-shift operations, reduce commute stress, and ensure smooth daily travel for IT professionals, managers, and support staff."
},
{
"name": "Corporate Cabs Hadapsar Magarpatta",
"description": "Corporate Cabs Hadapsar Magarpatta delivers premium corporate transport solutions for companies located in Hadapsar and Magarpatta. The service features professional drivers, well-maintained vehicles including sedans and SUVs, and flexible scheduling to meet the diverse travel needs of executives, employees, and visiting clients. It ensures reliability, professionalism, and efficient corporate mobility, helping organizations maintain punctuality and smooth operations."
},
{
"name": "Office Pickup Drop Magarpatta",
"description": "Office Pickup Drop Magarpatta provides structured and safe daily commute solutions for office employees across Magarpatta and Hadapsar. The service includes planned routes, shift-based pickups, and drop-offs, trained drivers, and well-maintained vehicles. It aims to enhance employee convenience, reduce travel time, and ensure consistent punctuality for both small and large corporate offices in the area."
},
{
"name": "Magarpatta Employee Shuttle",
"description": "Magarpatta Employee Shuttle offers efficient bulk transportation for employees working in IT and corporate offices in Magarpatta. The service uses minibuses and shuttle vans to manage large staff movements, with dedicated routes, multi-shift support, safety protocols, and GPS tracking. It reduces logistical challenges for HR and transport managers while ensuring employees have a comfortable and reliable commute every day."
},
{
"name": "Business Cab Magarpatta City",
"description": "Business Cab Magarpatta City provides professional taxi services for corporate travel, client meetings, and business trips within Magarpatta and nearby areas. Equipped with clean sedans and SUVs, the service prioritizes comfort, punctuality, and safety. Companies and visiting executives benefit from hassle-free bookings, trained chauffeurs, and flexible routes tailored for business requirements."
},
{
"name": "Staff Commute Magarpatta",
"description": "Staff Commute Magarpatta specializes in daily employee transportation across Magarpatta and Hadapsar. The service ensures structured pickups and drops, adherence to shift schedules, and safe driving standards. With reliable vehicles and professional drivers, it reduces commute stress, helps companies maintain attendance consistency, and provides employees with a seamless and secure journey to work and back."
},
{
"name": "Best Corporate Cabs Magarpatta",
"description": "Best Corporate Cabs Magarpatta delivers top-quality corporate transportation services with a focus on reliability, comfort, and professionalism. Featuring luxury sedans, spacious SUVs, and highly trained drivers, the service caters to executives, managers, and visiting clients. It emphasizes on-time pickups, efficient routing, safety measures, and premium customer experience for all corporate commuting needs."
},
{
"name": "Monthly Cab Magarpatta",
"description": "Monthly Cab Magarpatta offers long-term cab rental solutions for organizations requiring consistent daily employee commute services. With dedicated vehicles and fixed monthly plans, it ensures uninterrupted transportation, predictable budgeting, and reliable service. The service supports multi-shift schedules, reduces administrative workload, and ensures smooth operations for businesses of all sizes."
},
{
"name": "Affordable Office Cab Magarpatta",
"description": "Affordable Office Cab Magarpatta provides budget-friendly daily transport solutions for employees commuting to offices in Magarpatta and Hadapsar. The service balances cost-effectiveness with reliability, offering clean vehicles, trained drivers, and structured routes. It is ideal for startups, small companies, and offices seeking dependable yet economical commuting options for staff."
},
{
"name": "Corporate Sedan Cab Magarpatta",
"description": "Corporate Sedan Cab Magarpatta delivers premium sedan-based transportation for executives, managers, and business visitors. The service emphasizes professional driving, timely arrivals, vehicle cleanliness, and comfort. It is suitable for inter-office travel, client meetings, and corporate events, ensuring a refined and efficient travel experience for corporate clientele."
},
{
"name": "Corporate SUV Magarpatta",
"description": "Corporate SUV Magarpatta provides spacious and comfortable SUVs for team travel, executive commutes, and long-distance corporate trips. The service focuses on safety, reliability, and comfort, making it ideal for group movements, industrial visits, and multi-person corporate travel requirements within Magarpatta and neighboring areas."
},
{
"name": "IT Park Shuttle Magarpatta",
"description": "IT Park Shuttle Magarpatta offers dedicated shuttle services for employees working in Magarpatta IT Park. The service operates fixed routes, accommodates multiple shifts, and uses GPS-enabled vans for secure and timely travel. It helps reduce traffic congestion, simplifies employee transportation logistics, and ensures a seamless commute experience for IT professionals and staff."
},
{
"name": "Outstation Cab Magarpatta",
"description": "Outstation Cab Magarpatta provides long-distance travel solutions for corporate trips, client visits, factory tours, and business meetings outside Magarpatta. With comfortable vehicles, professional drivers, and fully planned routes, the service ensures safe, punctual, and convenient intercity travel tailored for business requirements."
},
{
"name": "Chauffeur Car Magarpatta",
"description": "Chauffeur Car Magarpatta delivers premium car services with trained professional drivers for executives, managers, and visiting clients. The service emphasizes safety, discretion, punctuality, and comfort, ensuring a high-end corporate travel experience for inter-office travel, client meetings, and airport transfers in Magarpatta and surrounding areas."
},
{
"name": "Corporate Fleet Magarpatta",
"description": "Corporate Fleet Magarpatta provides businesses with a dedicated fleet of vehicles including sedans, SUVs, and staff cabs. The service ensures organized transportation for employees, executives, and corporate visitors, offering reliable, scalable, and professionally managed fleet solutions for multi-shift operations, long-term rentals, and large-scale corporate mobility."
}
],

"tableData": [
["Magarpatta IT Cab Service", "Corporate Cabs Hadapsar Magarpatta"],
["Office Pickup Drop Magarpatta", "Magarpatta Employee Shuttle"],
["Business Cab Magarpatta City", "Staff Commute Magarpatta"],
["Best Corporate Cabs Magarpatta", "Monthly Cab Magarpatta"],
["Affordable Office Cab Magarpatta", "Corporate Sedan Cab Magarpatta"],
["Corporate SUV Magarpatta", "IT Park Shuttle Magarpatta"],
["Outstation Cab Magarpatta", "Chauffeur Car Magarpatta"],
["Corporate Fleet Magarpatta", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Magarpatta City",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services for employees and executives commuting to Magarpatta City, ensuring timely and hassle-free travel."
  },
  {
    "WhyChooseheading": "Punctual Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure on-time pickups and drops, helping corporate staff reach offices and business centers in Magarpatta City efficiently and reliably."
  },
  {
    "WhyChooseheading": "Professional & Courteous Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs provide safe, disciplined, and comfortable travel, maintaining high standards of professionalism for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and designed for safe and comfortable corporate commuting."
  },
  {
    "WhyChooseheading": "Flexible Corporate Travel Packages",
    "WhyChoosedescription": "We offer customized cab rental plans tailored to the commuting requirements of businesses and employees in Magarpatta City."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Assistance",
    "WhyChoosedescription": "Our team provides round-the-clock support for scheduling, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is simplified through our seamless booking process and reliable coordination, making employee transportation stress-free."
  }
]































  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Magarpatta City?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for companies and IT parks in Magarpatta City.',
  },
  {
    question: 'What types of corporate cab services are available in Magarpatta City?',
    answer: 'We provide employee transportation, point-to-point pickups and drops, shuttle services, and dedicated fleet solutions for corporate offices.',
  },
  {
    question: 'Do you offer daily employee transportation for Magarpatta City companies?',
    answer: 'Yes, we offer daily commute solutions with customized routes based on employee locations and office timings.',
  },
  {
    question: 'How can companies book corporate cab services for Magarpatta City?',
    answer: 'Companies can book via our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'What vehicle types do you offer for corporate cab services?',
    answer: 'We provide hatchbacks, sedans, SUVs, luxury cars, tempo travellers, and mini-buses to meet corporate requirements.',
  },
  {
    question: 'Do you provide flexible monthly and long-term cab contracts?',
    answer: 'Yes, we offer flexible monthly, quarterly, and annual corporate transportation contracts with transparent pricing.',
  },
  {
    question: 'Are safety and tracking features included in the service?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you support multiple shift-based cab scheduling?',
    answer: 'Yes, we provide cab services for multiple shift timings, including rotational and late-night shifts.',
  },
  {
    question: 'What payment options are available for corporate cab services in Magarpatta City?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Abhishek Patankar',
    feedback: 'Excellent cab service for our Magarpatta office. Very professional drivers and always on time.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Manasi Gokhale',
    feedback: 'Pune Corporate Cars India Private Limited manages our employee transportation flawlessly. Highly dependable service in Magarpatta City.',
    rating: 5,
  },
];




















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Magarpatta City",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-magarpatta.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited offers reliable corporate cab services in Magarpatta City, Pune, including IT park employee transport, office pickup and drop, staff shuttles, business travel, and chauffeur-driven sedans and SUVs. Perfect for companies, IT parks, and corporate offices in Magarpatta.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "4800", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-magarpatta-city"
  }
};






  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Magarpatta City | Employee & IT Park Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited offers reliable corporate cab services in Magarpatta City, Pune, including IT park employee transport, office pickup and drop, staff shuttles, business travel, and chauffeur-driven sedans and SUVs. Perfect for companies, IT parks, and corporate offices in Magarpatta."
  />

  <meta
    name="keywords"
    content="Magarpatta IT Cab Service, Corporate Cabs Hadapsar Magarpatta, Office Pickup Drop Magarpatta, Magarpatta Employee Shuttle, Business Cab Magarpatta City, Staff Commute Magarpatta, Best Corporate Cabs Magarpatta, Monthly Cab Magarpatta, Affordable Office Cab Magarpatta, Corporate Sedan Cab Magarpatta, Corporate SUV Magarpatta, IT Park Shuttle Magarpatta, Outstation Cab Magarpatta, Chauffeur Car Magarpatta, Corporate Fleet Magarpatta"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/30.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinmagarpatta;